export default "__VITE_ASSET__DV_H1mJq__"